<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="24">
        <el-row :gutter="20" class="mgb20">
          <el-col :span="8">
            <el-card shadow="hover" :body-style="{padding: '0px'}">
              <div class="grid-content grid-con-1">
                <i class="ldms-font ldms-nian"></i>
                <div class="grid-cont-right">
                  <div class="grid-num">{{dataAll.year.totalMoney}}</div>
                  <div>年销售额
                    <span style="color: #F56C6C" v-if="dataAll.year.scaleMoney <0">{{(-1*dataAll.year.scaleMoney)+'%↓'}}</span>
                    <span style="color: #67C23A" v-else>{{dataAll.year.scaleMoney+'%↑'}}</span>
                  </div>
                </div>
                <div class="grid-cont-right">
                  <div class="grid-num">{{dataAll.year.totalCount}}</div>
                  <div>年配货数
                    <span style="color: #F56C6C" v-if="dataAll.year.scaleCount <0">{{(-1*dataAll.year.scaleCount)+'%↓'}}</span>
                    <span style="color: #67C23A" v-else>{{dataAll.year.scaleCount+'%↑'}}</span>
                  </div>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="8">
            <el-card shadow="hover" :body-style="{padding: '0px'}">
              <div class="grid-content grid-con-2">
                <i class="ldms-font ldms-yue"></i>
                <div class="grid-cont-right">
                  <div class="grid-num">{{dataAll.month.totalMoney}}</div>
                  <div>月销售额
                    <span style="color: #F56C6C" v-if="dataAll.month.scaleMoney <0">{{(-1*dataAll.month.scaleMoney)+'%↓'}}</span>
                    <span style="color: #67C23A" v-else>{{dataAll.month.scaleMoney+'%↑'}}</span>
                  </div>
                </div>
                <div class="grid-cont-right">
                  <div class="grid-num">{{dataAll.month.totalCount}}</div>
                  <div>月配货数
                    <span style="color: #F56C6C" v-if="dataAll.month.scaleCount <0">{{(-1*dataAll.month.scaleCount)+'%↓'}}</span>
                    <span style="color: #67C23A" v-else>{{dataAll.month.scaleCount+'%↑'}}</span>
                  </div>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="8">
            <el-card shadow="hover" :body-style="{padding: '0px'}">
              <div class="grid-content grid-con-3">
                <i class="ldms-font ldms-ri"></i>
                <div class="grid-cont-right">
                  <div class="grid-num">{{dataAll.day.totalMoney}}</div>
                  <div>日销售额
                    <span style="color: #F56C6C" v-if="dataAll.day.scaleMoney <0">{{(-1*dataAll.day.scaleMoney)+'%↓'}}</span>
                    <span style="color: #67C23A" v-else>{{dataAll.day.scaleMoney+'%↑'}}</span>
                  </div>
                </div>
                <div class="grid-cont-right">
                  <div class="grid-num">{{dataAll.day.totalCount}}</div>
                  <div>日配货数
                    <span style="color: #F56C6C" v-if="dataAll.day.scaleCount <0">{{(-1*dataAll.day.scaleCount)+'%↓'}}</span>
                    <span style="color: #67C23A" v-else>{{dataAll.day.scaleCount+'%↑'}}</span>
                  </div>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <div class="head">
      <el-form :inline="true" :model="selectForm" ref="orderReceipt" class="demo-form-inline" size="mini">
        <el-form-item>
          <el-date-picker
            v-model="selectForm.dateTime"
            type="date"
            :picker-options="pickerDate"
            format="yyyy 年 MM 月 dd 日"
            value-format="timestamp"
            @change="changeDate">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-select multiple collapse-tags v-model="selectForm.categoryId" clearable style="width: 150px;margin-right: 5px"  placeholder="栏目(默认全部)">
            <el-option v-for="item in appInfo.appCategoryList" :key="item.categoryId" :label="item.categoryName" :value="item.categoryId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-button size="mini" type="primary" @click="search" icon="el-icon-search">搜索</el-button>
      </el-form>
    </div>
    <div class="echarts" :style="{height: windowHeight + 'px'} ">
      <chart theme="macarons" :options="polar" ref="echar" :init-options="initOptions" :auto-resize="true" @timelinechanged="timelinechanged"/>
    </div>
  </div>
</template>

<script>
import ECharts from 'vue-echarts/components/ECharts'
import 'echarts/lib/chart/line'
import theme from '../../../ECharts/macarons.json'
import 'echarts/theme/dark'
import { finance, financeByAllDetail } from '../../../api/ordersStatistics'
import { getAppInfo } from '../../../api/app'

ECharts.registerTheme('macarons', theme)
export default {
  components: {
    chart: ECharts
  },
  data: function () {
    return {
      selectForm: {
        appId: '',
        categoryId: [],
        dateType: '2',
        dateTime: new Date().getTime()
      },
      appInfo: {},
      dataAll: {
        day: {},
        month: {},
        year: {}
      },
      findDate: [],
      pickerDate: {
        shortcuts: [{
          text: '今天',
          onClick (picker) {
            picker.$emit('pick', new Date())
          }
        }, {
          text: '上月',
          onClick (picker) {
            picker.$emit('pick', new Date() - 3600 * 1000 * 24 * 31)
          }
        }, {
          text: '去年',
          onClick (picker) {
            picker.$emit('pick', new Date() - 3600 * 1000 * 24 * 366)
          }
        }]
      },
      windowHeight: '',
      initOptions: {},
      initDate: '',
      timeline: {
        scope: [],
        xLine: [],
        data: {}
      },
      timeLineIndex: '',
      polar: {
        baseOption: {
          timeline: {
            axisType: 'category',
            orient: 'vertical',
            left: null,
            right: 40,
            top: 20,
            bottom: 2,
            width: 55,
            height: null,
            // realtime: false,
            loop: true,
            autoPlay: false,
            // currentIndex: this.timeline.scope.length - 1,
            playInterval: 1000,
            inverse: true,
            // data: this.timeline.scope,
            label: {
              position: 20,
              formatter: function (value, index) {
                return new Date(value).format('yyyy年M') + '月'
              }
            }
          },
          title: {
            subtext: '',
            textStyle: {
              align: 'center'
            }
          },
          tooltip: {},
          legend: {
          },
          toolbox: {
            show: true,
            feature: {
              magicType: {type: ['line', 'bar']},
              saveAsImage: {show: true}
            },
            right: '100'
          },
          calculable: true,
          grid: {
            top: 80,
            bottom: 50,
            left: 50,
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'line',
                lineStyle: {
                  type: 'dashed'
                }
              }
            }
          },
          xAxis: {
            type: 'category',
            axisLabel: {
              interval: 0,
              formatter: function (value, index) {
                if (index % 2 === 0) {
                  return new Date(value).format('M-d')
                }
                return new Date(value).format('\nM-d')
              }
            },
            splitLine: {show: false}
          },
          yAxis: [
            {
              type: 'value',
              name: '销售（元）'
            }
          ]
        },
        options: []
      }
    }
  },
  created () {
    this.$nextTick(() => {
      this.windowHeight = document.documentElement.offsetHeight - 370
      this.$refs.echar.showLoading()
    })
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.selectForm.appId = to.params.id
      getAppInfo(to.params.id).then((response) => {
        vm.appInfo = response.data.data
        finance(vm.selectForm).then((response) => {
          vm.initDate = response.data.data
          vm.init(response.data.data)
        })
      })
      financeByAllDetail(vm.selectForm).then((response) => {
        vm.dataAll = response.data.data
      })
    })
  },
  methods: {
    search () {
      this.$refs.echar.showLoading()
      let _this = this
      financeByAllDetail(this.selectForm).then((response) => {
        _this.dataAll = response.data.data
      })
      finance(this.selectForm).then((response) => {
        console.log(response.data.data)
        _this.initDate = response.data.data
        _this.init(response.data.data)
      })
    },
    changeDate () {
      let _this = this
      financeByAllDetail(this.selectForm).then((response) => {
        _this.dataAll = response.data.data
      })
    },
    init (financeData) {
      this.polar.options = []
      let _this = this
      let timeline = this.wei.getMonth(this.selectForm.dateTime)
      let timeLineIndex = new Date(this.selectForm.dateTime).getMonth()
      this.timeLineIndex = new Date(this.selectForm.dateTime).getMonth()
      this.$nextTick(() => {
        this.timeline.scope = timeline
        this.polar.baseOption.legend.data = this.appInfo.appCategoryList.map(function (item) {
          return item.categoryName
        })
        for (var x = 0; x < timeline.length; x++) {
          this.timeline.xLine[x] = this.wei.getDate(timeline[x])
          this.polar.options.push({
            title: {text: new Date(timeline[x]).format('yyyy年M月')},
            series:
              (function () {
                var pi = []
                var series = []
                for (var s = 0; s < _this.appInfo.appCategoryList.length; s++) {
                  let financeDate
                  if (x === new Date(_this.selectForm.dateTime).getMonth()) {
                    financeDate = _this.wei.createMonth(_this.initDate[s].data, timeline[x])
                  } else {
                    financeDate = _this.wei.createMonth([], timeline[x])
                  }
                  financeDate.name = _this.appInfo.appCategoryList[s].categoryName
                  pi.push(financeDate)

                  var dataList = {
                    data: financeDate.daysOfMonth.map(function (item) {
                      return {
                        name: item.date,
                        value: item.moneySum * 1,
                        label: {
                          normal: {
                            show: true
                          }
                        }
                      }
                    })
                  }
                  series.push(dataList)
                }
                var piData = {}
                piData.data = pi.map(function (item) {
                  return {
                    name: item.name,
                    value: item.sum
                  }
                })
                series.push(piData)
                return series
              }())
          })
        }
        this.polar.baseOption.timeline.currentIndex = timeLineIndex
        this.polar.baseOption.timeline.data = this.timeline.scope
        this.polar.baseOption.xAxis.data = this.timeline.xLine[timeLineIndex]
        this.polar.baseOption.series = (function () {
          var serie = []
          for (var i = 0; i < _this.appInfo.appCategoryList.length; i++) {
            var item = {
              name: _this.appInfo.appCategoryList[i].categoryName,
              type: 'line',
              areaStyle: {
                opacity: 0.2
              },
              markLine: {
                data: [
                  {type: 'average', name: '平均值'}
                ]
              }
            }
            serie.push(item)
          }
          var pies = {
            name: '销售占比',
            type: 'pie',
            center: ['75%', '25%'],
            radius: ['10%', '20%'],
            roseType: 'angle',
            tooltip: {
              formatter: '{a} <br/>{b} : {c}元 ({d}%)'
            },
            label: {
              normal: {
                borderRadius: 5,
                padding: 5,
                textBorderColor: '#fff',
                textBorderWidth: 5
              }
            },
            itemStyle: {
              opacity: 0.1,
              normal: {
                shadowBlur: 100,
                shadowColor: 'rgba(0, 0, 0, 0.3)'
              }
            }
          }
          serie.push(pies)
          return serie
        }())
        this.$refs.echar.mergeOptions(this.polar)
        this.$refs.echar.hideLoading()
      })
    },
    timelinechanged (params) {
      this.$refs.echar.showLoading()
      let _this = this
      this.selectForm.dateTime = new Date(this.timeline.scope[params.currentIndex])
      financeByAllDetail(this.selectForm).then((response) => {
        _this.dataAll = response.data.data
      })
      finance(this.selectForm).then((response) => {
        let dateList = response.data.data
        var pi = []
        var series = []
        for (var s = 0; s < dateList.length; s++) {
          let financeDate
          financeDate = _this.wei.createMonth(dateList[s].data, _this.timeline.scope[params.currentIndex])
          financeDate.name = dateList[s].name
          pi.push(financeDate)
          var dataList = {
            data: financeDate.daysOfMonth.map(function (item) {
              return {
                name: item.date,
                value: item.moneySum * 1,
                label: {
                  normal: {
                    show: true
                  }
                }
              }
            })
          }
          series.push(dataList)
        }
        var piData = {}
        piData.data = pi.map(function (item) {
          return {
            name: item.name,
            value: item.sum
          }
        })
        series.push(piData)
        _this.polar.options[params.currentIndex].series = series
        _this.$refs.echar.hideLoading()
      })
      this.polar.baseOption.timeline.currentIndex = params.currentIndex
      this.polar.baseOption.xAxis.data = this.timeline.xLine[params.currentIndex]
      this.$refs.echar.mergeOptions(this.polar)
      // myChart.setOption(option, true);
    }
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  .grid-content
    display: flex
    align-items: center
    height: 100px
  .grid-cont-right
    flex: 1
    text-align: center
    font-size: 12px
    color: #999
  .grid-num
    font-size: 30px
    font-weight: bold
  .ldms-font
    font-size: 50px
    width: 100px
    height: 100px
    text-align: center
    line-height: 100px
    color: #fff
  .grid-con-1 .ldms-font
    background: rgb(45, 140, 240)
  .grid-con-1 .grid-num
    color: rgb(45, 140, 240)
  .grid-con-2 .ldms-font
    background: rgb(100, 213, 114)
  .grid-con-2 .grid-num
    color: #65d472
  .grid-con-3 .ldms-font
    background: rgb(242, 94, 67)
  .grid-con-3 .grid-num
    color: rgb(242, 94, 67)
  .head
    width 100%
    padding 10px
    background: #fff
    border-radius: 8px 8px 0 0
    margin-top: 12px
    padding-left: 30px
    padding-right: 30px
  .echarts
    width: 100%
    height 100%
    margin: auto
    text-align: center
    background: #fff
</style>
